import React, { useEffect, useState } from 'react';
import './App.css';

function App() {
  const [isAboutOpen, setIsAboutOpen] = useState(false);

  useEffect(() => {
    if (!isAboutOpen) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsAboutOpen(false);
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isAboutOpen]);

  return (
    <div className="App">
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <div className="aa-logo ai-logo"><span style={{color: '#000000'}}>A</span><span className="maroon-highlight">i</span></div>
          </div>
          <div className="nav-menu">
            <a href="#products" className="nav-link" title="Products">
              <div className="nav-icon-marker products-icon">
                <i className="fas fa-cube"></i>
              </div>
            </a>
            <button type="button" className="nav-link nav-link-btn" title="About" onClick={() => setIsAboutOpen(true)}>
              <div className="nav-icon-marker about-icon">
                <i className="fas fa-info-circle"></i>
              </div>
            </button>
            <a href="mailto:thejourney.proceed@gmail.com" className="nav-link" title="Email us">
              <div className="nav-icon-marker contact-icon">
                <i className="fas fa-envelope"></i>
              </div>
            </a>
          </div>
        </div>
      </nav>

      <main>
        <section id="home" className="hero">
          <div className="hero-container">
            <h1 className="hero-title">
              <div className="hero-logo">
                <div className="hero-aa-logo">A<span className="maroon-highlight">A</span>dh<span className="maroon-highlight">i</span></div>
              </div>
              <span className="hero-secondary">solutions</span>
            </h1>
            <p className="hero-subtitle">
              Innovative AI solutions for the future
            </p>
            <p className="hero-description">
              We build cutting-edge artificial intelligence solutions that transform businesses and drive innovation forward.
            </p>
          </div>
        </section>

        <section id="products" className="products">
          <div className="container">
            <h2 className="section-title">Our Products</h2>

            <div className="product-demo-container">
              <div className="demo-box">
                <div className="video-container video-placeholder">
                  <i className="fas fa-play-circle"></i>
                  <p>Product demo coming soon</p>
                </div>
              </div>
            </div>

            <div className="products-grid">
              <a
                href="https://learnkin.aadhisolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="product-card product-card-link"
              >
                <span className="product-card-badge">Live now</span>
                <div className="product-icon">
                  <svg width="36" height="36" viewBox="0 0 1024 1024" aria-hidden="true">
                    <rect width="1024" height="1024" rx="150" fill="#B23A5E" />
                    <path d="M 372 268 a 56 56 0 0 1 56 56 v 320 h 224 a 56 56 0 0 1 56 56 v 0 a 56 56 0 0 1 -56 56 h -280 a 56 56 0 0 1 -56 -56 v -376 a 56 56 0 0 1 56 -56 Z" fill="#FFFFFF" />
                    <circle cx="702" cy="330" r="72" fill="#FFD166" />
                  </svg>
                </div>
                <h3>Learnkin</h3>
                <p>An AI tutor for your child and a parental control center for you — schedule tests, review report cards, and track usage, all in one install</p>
                <span className="product-card-cta">Visit Learnkin <i className="fas fa-arrow-right"></i></span>
              </a>

              <div className="product-card product-card-soon">
                <span className="product-card-badge product-card-badge-soon">Coming soon</span>
                <div className="product-icon">
                  <svg width="36" height="36" viewBox="0 0 32 32" aria-hidden="true">
                    <rect width="32" height="32" rx="8" fill="#cc785c"/>
                    <line x1="16" y1="16" x2="6" y2="7" stroke="rgba(255,255,255,0.55)" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="16" y1="16" x2="26" y2="7" stroke="rgba(255,255,255,0.55)" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="16" y1="16" x2="6" y2="25" stroke="rgba(255,255,255,0.55)" strokeWidth="2" strokeLinecap="round"/>
                    <line x1="16" y1="16" x2="26" y2="25" stroke="rgba(255,255,255,0.55)" strokeWidth="2" strokeLinecap="round"/>
                    <circle cx="6" cy="7" r="2.8" fill="rgba(255,255,255,0.75)"/>
                    <circle cx="26" cy="7" r="2.8" fill="rgba(255,255,255,0.75)"/>
                    <circle cx="6" cy="25" r="2.8" fill="rgba(255,255,255,0.75)"/>
                    <circle cx="26" cy="25" r="2.8" fill="rgba(255,255,255,0.75)"/>
                    <circle cx="16" cy="16" r="4.5" fill="white"/>
                  </svg>
                </div>
                <h3>Intention</h3>
                <p>An intelligent API orchestration platform — connect your APIs, databases, and files to an agentic chat interface.</p>
              </div>
            </div>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="container">
          <p>&copy; {new Date().getFullYear()} AAdhi Solutions. All rights reserved.</p>
          <p style={{fontSize: '12px', opacity: '0.7', marginTop: '4px'}}>ABN: 82991277308</p>
        </div>
      </footer>

      {isAboutOpen && (
        <div className="modal-overlay" onClick={() => setIsAboutOpen(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="modal-close" aria-label="Close" onClick={() => setIsAboutOpen(false)}>
              <i className="fas fa-times"></i>
            </button>
            <h2 className="section-title modal-title">About AAdhi</h2>
            <p className="about-text">
              We are a forward-thinking AI startup dedicated to creating innovative solutions that empower businesses to harness the full potential of artificial intelligence. Our team combines deep technical expertise with creative problem-solving to deliver transformative results.
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
